import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { IoClose } from 'react-icons/io5'
import { BeatLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';
import ccLogo from '../assets/logo/cc_logo.png';
import { IoMdArrowBack } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { HiEyeSlash, HiMiniEye } from "react-icons/hi2";
import { AccountProfile, clearAccountProfile } from '../redux/ApiSlice/AccountProfileSlice';
import { addSwitchAccount, removeSwitchAccount } from '../redux/ApiSlice/SwitchAccountSlice';
import { setAuthData } from '../redux/ApiSlice/Auth/AuthSlice';
import { setClearHomepageVideos } from '../redux/ApiSlice/HomePageVideoSlice';

export default function SwitchAccount() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [addAccount, setAddAccount] = useState(false);
    const [deleteConfirmation, setDeleteConfirmation] = useState(null);
    const { SwitchAccountList, AccountAdded } = useSelector((state) => state.switchAccount);
    const [loginAccounts, setLoginAccounts] = useState(SwitchAccountList?.sessions || []);
    const [isLoading, setIsLoading] = useState(false);
    const hasSavedAccounts = (loginAccounts?.length || 0) > 0;
    const showAddAccountForm = addAccount || !hasSavedAccounts;

    useEffect(() => {
        setLoginAccounts(SwitchAccountList?.sessions || []);
    }, [SwitchAccountList?.sessions]);

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (email === '' || password === '') {
            toast.error('Please fill in all fields')
            return
        }
        setIsLoading(true);
        try {
            const response = await dispatch(addSwitchAccount({ email, password }))
            if (response.payload.access) {
                dispatch(setAuthData({
                    access: response.payload.access,
                    refresh: response.payload.refresh,
                    session_key: response.payload.session_key,
                    browser_group_id: response.payload.browser_group_id,
                }));
                // localStorage.setItem('refreshToken', response.payload.refresh)
                toast.success("Account added successfully")
                await dispatch(clearAccountProfile())
                await dispatch(setClearHomepageVideos())
                await dispatch(AccountProfile())
                setTimeout(() => {
                    navigate("/account")
                }, 2000);
                setIsLoading(false);
            }
            if (response.payload.error) {
                toast.error(response.payload.error)
                setIsLoading(false);
            }
        } catch (error) {
            console.error('Error adding account:', error)
            toast.error('Error adding account')
            setIsLoading(false);
        } finally {
            setIsLoading(false);
        }
    }

    const handleRemoveAccount = async (session_key) => {
        try {
            await dispatch(removeSwitchAccount({ session_key }))
            toast.success("Account removed")
            setLoginAccounts(prevAccounts => prevAccounts.filter(account => account.session_key !== session_key))
        }
        catch (error) {
            console.error('Error removing account:', error)
            toast.error('Error removing account')
        }
        setDeleteConfirmation(null)
    }

    // const handleSwitchAccount = async (item) => {
    //     try {
    //         if (item) {
    //             await dispatch(clearAccountProfile())
    //             localStorage.setItem('accessToken', item);
    //             await dispatch(AccountProfile())

    //             setTimeout(() => {
    //                 navigate("/account")
    //             }, 2000);
    //         }
    //     } catch (error) {
    //         console.error("Error switching account:", error);
    //     }
    // };

    return (
        <div className="bg-white dark:bg-[#1E1D21] min-h-screen">
            <div className="px-4 pt-3">
                <IoMdArrowBack
                    onClick={() => navigate("/account")}
                    className="text-[22px] text-black dark:text-white cursor-pointer"
                />
            </div>

            <div className="h-full w-full relative md:overflow-hidden">
                <div className="grid grid-cols-12 mt-10 gap-3 overflow-y-scroll md:overflow-hidden">
                    <div className="col-span-12 w-full px-5 bg-white dark:bg-[#1E1D21]">
                        <form onSubmit={handleSubmit} className="pt-2">
                            <img src={ccLogo} className="h-16 w-16" alt="logo" />

                            <p className="text-[24px] font-bold mt-2 leading-none text-black dark:text-white">
                                Add Account
                            </p>
                            <p className="text-[12px] font-semibold text-[#5a5a5a] dark:text-gray-300 mt-1.5">
                                After adding your account, you can switch
                                between them easily.
                            </p>

                            <div className="px-4 pt-4 pb-3 rounded-xl border-2 border-[#BDE6FF] mt-4">
                                <p className="text-[12px] font-semibold text-black dark:text-white">
                                    Email or phone number
                                </p>
                                <input
                                    required
                                    type="text"
                                    name="email"
                                    value={email}
                                    placeholder="myusername@gmail.com"
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full text-[14px] focus:outline-none bg-white dark:bg-[#1E1D21] text-black dark:text-white"
                                />
                            </div>

                            <div className="px-4 pt-4 pb-3 rounded-xl border-2 border-[#BDE6FF] mt-3">
                                <p className="text-[12px] font-semibold text-black dark:text-white">Password</p>
                                <div className="relative">
                                    <input
                                        required
                                        name="password"
                                        value={password}
                                        type={showPassword ? "text" : "password"}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Enter your password"
                                        className="w-full text-[14px] focus:outline-none bg-white dark:bg-[#1E1D21] text-black dark:text-white"
                                    />
                                    <p className="absolute top-1.5 z-50 right-2 cursor-pointer">
                                        {showPassword ? (
                                            <HiEyeSlash
                                                className="text-gray-500"
                                                onClick={() => setShowPassword(!showPassword)}
                                            />
                                        ) : (
                                            <HiMiniEye
                                                className="text-gray-500"
                                                onClick={() => setShowPassword(!showPassword)}
                                            />
                                        )}
                                    </p>
                                </div>
                            </div>

                            <div className="w-full flex justify-center items-center flex-col mt-6">
                                <button
                                    disabled={isLoading || !email || !password}
                                    className={`w-full h-12 text-[20px] font-semibold rounded-xl transition-all ${!email || !password
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-[#BDE6FF] text-gray-900'
                                        }`}
                                >
                                    {isLoading ? (
                                        <BeatLoader
                                            size={10}
                                            color={"#000"}
                                            loading={isLoading}
                                        />
                                    ) : (
                                        "Login"
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* Confirmation Modal */}
            {deleteConfirmation && (
                <div
                    className="absolute inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
                    onClick={() => setDeleteConfirmation(null)}
                >
                    <div
                        className="bg-white dark:bg-[#333333] rounded-lg shadow-lg p-6 px-4 flex flex-col items-center gap-y-3"
                        onClick={e => e.stopPropagation()}
                    >
                        <p className="text-[14px] font-bold text-red-500 mb-2">
                            Are you sure you want to remove this account?
                        </p>
                        <div className="flex gap-4 mt-2">
                            <button
                                onClick={() => setDeleteConfirmation(null)}
                                className="bg-gray-300 hover:bg-gray-400 text-black text-[12px] px-3 py-1 rounded"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => handleRemoveAccount(deleteConfirmation)}
                                className="bg-red-500 hover:bg-red-600 text-white text-[12px] px-3 py-1 rounded"
                            >
                                Remove
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}